<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account"
        :primary-fields="[ 'name', 'carrier_settings.charge_account', 'parent', 'carrier_settings.carrier', 'status' ]"
        @apply="reload"
        @ready="load"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoadingAccounts"
        shadow="never"
      >
        <AccountsTable :accounts.sync="accounts">
          <template v-slot:peek="{ account }">
            <AccountPeek :account="account" />
          </template>
        </AccountsTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="accounts.page"
          :page-size.sync="accounts.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="accounts.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AccountsTable from '@/components/Application/Sales/Accounts/Table'
import AccountPeek from '@/components/Application/Sales/Accounts/Account/Peek'
import Filter, { IS, IS_NOT } from '@/plugins/sdk/Filter'
import { CREATED, UPDATED, DELETED, RESTORED } from '@/plugins/sdk/Events'

export default {
  components: {
    Filters,
    AccountsTable,
    AccountPeek
  },
  data () {
    return {
      actions: [
        ...this.$parent.actions,
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoadingAccounts: true,
      portfolios: [],
      accounts: [],
      filters: []
    }
  },
  computed: {
    portfolioFilter () {
      return new Filter('portfolio', IS, this.$_.map(this.portfolios, 'id'))
    }
  },
  mounted () {
    this
      .$sdk
      .account
      .on([ CREATED, UPDATED, DELETED, RESTORED ], this.reload, this)
  },
  methods: {
    load () {
      this
        .$sdk
        .dictionary_portfolio
        .list(builder => {
          builder.limit = 1000
        })
        .then(portfolios => {
          this.portfolios = portfolios

          this
            .$sdk
            .account
            .list(builder => {
              builder.include = [ 'portfolio', 'b_group', 'events.notes' ]
              builder.filters = [
                new Filter('status', IS_NOT, ['lead']),
                this.portfolioFilter,
                ...this.filters
              ]
              builder.order = 'name:asc'
            })
            .then(res => { this.accounts = res })
            .finally(() => { this.isLoadingAccounts = false })
        })
    },
    async reload () {
      this.isLoadingAccounts = true

      try {
        await this.accounts.reload(builder => {
          builder.filters = [
            new Filter('status', IS_NOT, ['lead']),
            this.portfolioFilter,
            ...this.filters
          ]
        })
      } catch {
        this.$message.error('Failed to load Accounts')
      }

      this.isLoadingAccounts = false
    }
  }
}
</script>
